import * as React from "react";

import {useUpdatePageSettings} from "#data-access/use-update-page-settings.ts";

import PageTemplateContext from "../page-template-context.ts";

type Props = {
    children: React.ReactNode;
};

const frameSettings = {
    noIndex: true,
    noFollow: true,
    footer: false,
    header: false,
    analytics: false,
    iOSSmartBanner: false,
};

/**
 * A page template that renders its children directly, to be used for routes
 * that are only rendered in an embedded context (e.g. in an iframe on a page).
 */
const EmbeddedPageTemplate = ({children}: Props): React.ReactElement => {
    // Update the page settings to customize for an iframe.
    useUpdatePageSettings(frameSettings, /* reset settings */ false);

    return (
        <PageTemplateContext.Provider value={{hasPageTemplate: true}}>
            {children}
        </PageTemplateContext.Provider>
    );
};

export default EmbeddedPageTemplate;
